<template>
  <div class="ui-tag" :class="{ active: (id && active) || (!id && !active) }" data-id="id-0">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'UiTag',
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-tag {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 get_vh(47px);
  min-width: get_vh(144px);
  @include fontSet(26px);
  z-index: 2;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 120%;
    height: 129%;
    // background-image: url('https://website.xdcdn.net/poster/58881/20250717/KxkQTIei.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: none;
  }
  &::after {
    content: '';
    position: absolute;
    bottom: -40%;
    left: -2%;
    width: get_vh(40px);
    height: get_vh(20px);
    // background-image: url('https://website.xdcdn.net/poster/58881/20250717/K7gHcC2c.png');
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: none;
  }
  i, .label-box {
    margin-top: get_vh(6px);
  }

  .label-box {
    .label-shadow {
      color: rgba(0, 0, 0, 0.4);
    }
    .label-text {
      color: #88A4E2;
    }
  }

  &.active {
    &::before {
      display: block;
    }
    .label-box {
      .label-text {
        color: #FFFFFF;
      }
    }
  }

  &[data-id="id-0"] {
    &::after {
      display: none !important;
    }
  }
}

@media screen and (max-aspect-ratio: 3/2) {
  .ui-tag {
    padding: 0 get_vw(47px);
    min-width: get_vw(144px);
    &::after {
      bottom: -43%;
      width: get_vw(40px);
      height: get_vw(20px);
    }
    i, .label-box {
      margin-top: get_vw(8px);
    }
  }
}
</style>